export const UnitsOfWeightInput = [
    {name:'kg',value:1},{name : 'lb',value:2},{name : 'oz',value:3},{name : 'gm',value:4}
]
